module.exports = __webpack_public_path__ + "static/media/heatSingle.f3271de4.JPG";